import { Box, Container, Typography, Button, TextField, Snackbar, Alert } from "@mui/material";
import NavBar from "../component/nav-bar";
import { useState } from "react";
import { PaystackButton } from "react-paystack";
import '../App.css'

const PAYSTACK_PUBLIC_KEY = "pk_live_485db31647eb76b20ff1f1f872187e850ebd37d1";

function BookAppointment() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        whatsapp: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const [responseM, setResponseM] = useState({
        'message': '',
        'severity': ''
    });

    const handleClose = () => {
        setResponseM({
            'message' : '',
            'severity': ''
        })
    }

    const amount = 1015000;

    const paystackConfig = {
        email: formData.email,
        amount,
        publicKey: PAYSTACK_PUBLIC_KEY,
        currency: "NGN",
        metadata: {
            name: formData.name,
            whatsapp: formData.whatsapp,
            email: formData.email,
        },
        onSuccess: (response) => {
            bookSession();
        },
        onClose: () => {
            setResponseM({
                message: 'Error making payment',
                severity: 'error'
            });
        },
    };

    async function bookSession() {
        try {
            const response = await fetch('https://nutriedu.com.ng/api/v1/book-appointment.php', {
                method: 'POST',
                headers: {
                    
                },
                body: JSON.stringify(formData)
            });
    
            const result = await response.json();
    
            if (result.success) {
                setResponseM({
                    message: 'We will be in touch with you shortly',
                    severity: 'success'
                });
            }
            else {
                setResponseM({
                    message: 'An error occurred, please contact support.',
                    severity: 'error'
                });
            }
        } catch (error) {
            setResponseM({
                message: 'An error occurred, please contact support.',
                severity: 'error'
            });
        }
    }

    const whatsapp_chat = () => {
        const encodedPhoneNumber = encodeURIComponent(2347059148543);
        const messageLines = [
            'Hello Good Day',
            "I'm from NutriEdu website"
          ];
          
        const encodedMessage = messageLines.map(line => encodeURIComponent(line)).join('%0A');
        
        const whatsappLink = `https://api.whatsapp.com/send?phone=${encodedPhoneNumber}&text=${encodedMessage}`;
      
        // Open the WhatsApp chat link in a new window or tab
        window.open(whatsappLink, '_blank');
    };
    

    return (
        <Box sx={{}}>
           
            <Container
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 2,
                    padding: 3
                }}
                maxWidth="md"
            >

                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: 'Fredoka One, sans-serif',
                        color: 'grey.800',
                        marginBottom: '20px',
                    }}
                >
                    Book an Appointment
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        marginBottom: '30px',
                    }}
                >
                    Get the opportunity to talk directly with our founder! Receive tailored nutrition tips, personal mentorship, and continuous counseling to guide you on your health journey.
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        marginBottom: '30px',
                    }}
                >
                    💰 <strong>Fee:</strong> ₦10,000
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        marginBottom: '30px',
                    }}
                >
                    📲 <strong>How It Works:</strong> Once payment is completed, we'll contact you via WhatsApp to arrange a session at a time that works for both of us. Sessions are usually conducted via WhatsApp calls.
                </Typography>

                {/* Input Fields */}
                <TextField
                    name="name"
                    label="Full Name"
                    variant="outlined"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={formData.name}
                    onChange={handleChange}
                />

                <TextField
                    name="email"
                    label="Email Address"
                    type="email"
                    variant="outlined"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={formData.email}
                    onChange={handleChange}
                />

                <TextField
                    name="whatsapp"
                    label="WhatsApp Number"
                    variant="outlined"
                    fullWidth
                    sx={{ marginBottom: 2 }}
                    value={formData.whatsapp}
                    onChange={handleChange}
                />

                <PaystackButton
                    {...paystackConfig}
                    className="paystack-button"
                    text="Book Your Appointment"
                    disabled={!formData.name || !formData.whatsapp || !formData.email}
                />

                {/* Support Text */}
                <Typography
                    sx={{
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        color: 'text.secondary',
                        marginTop: 2,
                        textAlign: 'center',
                    }}
                >
                    Having problems with payment?{' '}
                    <Typography
                        component="span"
                        sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            color: 'primary.main',
                        }}
                        onClick={whatsapp_chat}
                    >
                        Contact support
                    </Typography>
                </Typography>

            </Container>

            {
                responseM['message'] && 

                <Snackbar
                    open={true}
                    autoHideDuration={5000}
                    onClose={handleClose}
                >
                    <Alert
                        onClose={handleClose}
                        severity={responseM['severity']}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {responseM['message']}
                    </Alert>
                </Snackbar>
            }

        </Box>
    );
}

export default BookAppointment;
